import { CourseAssignment } from './course-assignments';
import { makeRequest, CommonRequestOptions } from './makeRequest';

export type UserCourseAssignment = CourseAssignment & {
   assignee_userid: number;
};

export type GetUserCourseAssignmentsOptions = CommonRequestOptions & {
   page?: number;
   pageSize?: number;
};

type GetUserCourseAssignmentsResult = {
   total: number;
   hasMore: boolean;
   course_assignments: UserCourseAssignment[];
};

export function getUserCourseAssignments(
   userid: number,
   { page, pageSize, ...common }: GetUserCourseAssignmentsOptions = {}
): Promise<GetUserCourseAssignmentsResult> {
   return makeRequest('get', `/users/${userid}/course_assignments`, {
      ...common,
      query: {
         page,
         pageSize,
      },
   });
}
